<script setup lang="ts">
    import { computed } from 'vue'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        comment: string | null
        value: number | null
        scaleLevels: { Value: number; Name: string; Definition?: string | null }[] | null
    }>()

    const emit = defineEmits<{
        (e: 'update-value', value: number | null): void
        (e: 'update-comment', comment: string | null): void
    }>()

    // ---------------- computed ----------------

    const hasScale = computed(() =>
        props.scaleLevels != null && props.scaleLevels.length > 0
    )

    // ---------------- actions ----------------

    function updateValue(val: number | null)
    {
        emit('update-value', val)
    }

    function updateComment(comment: string | null)
    {
        emit('update-comment', comment)
    }
</script>


<template>
    <div style="min-height: 450px;">

        <input v-if="!hasScale" type="number" :value="value" @input="updateValue(parseFloat($event.target.value))" class="form-control" />

        <div v-if="hasScale" class="list-group">
            <a v-for="sl in scaleLevels" class="list-group-item list-group-item-action text-center"
               @click="updateValue(sl.Value)" :class="{'bg-success': value === sl.Value, 'bg-white': value !== sl.Value}">
                <strong>{{sl.Value}} - {{sl.Name}}</strong>
                <p v-if="sl.Definition" class="mb-0">{{sl.Definition}}</p>
            </a>
        </div>

        <div v-if="value != null" class="text-center">
            <button type="button" class="btn btn-link mt1" @click="updateValue(null)">
                <i class="fa fa-times" aria-hidden="true"></i> Clear answer
            </button>
        </div>
        <br />

        <div style="margin-top: 15px;">
            <textarea rows="5" :value="comment" @input="updateComment($event.target.value)" class="form-control" placeholder="Comment..." />
        </div>
    </div>
</template>
